var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDomain = function SvgDomain(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "domain_a",
    x1: "0%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00B1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00C8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "domain_b",
    x1: "0%",
    x2: "101.131%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FB0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#domain_a)",
    d: "M58 24H3v26h36.61v3H2a2 2 0 0 1-2-2V11a2 2 0 0 1 2-2h57a2 2 0 0 1 2 2v32h-3V24zm0-3v-9H3v9h55zM7.5 18a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm6 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm6 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm1.42 15.18h2.532l-3.696 8.94h-.048L17.8 37.98l-1.908 4.14h-.048l-3.696-8.94h2.532l1.404 3.972 1.692-3.972h.048l1.692 3.972 1.404-3.972zm12.6 0h2.532l-3.696 8.94h-.048L30.4 37.98l-1.908 4.14h-.048l-3.696-8.94h2.532l1.404 3.972 1.692-3.972h.048l1.692 3.972 1.404-3.972zm12.452 0h2.532l-3.696 8.94h-.048l-1.908-4.14-1.908 4.14h-.048L37.2 33.18h2.532l1.404 3.972 1.692-3.972h.048l1.692 3.972 1.404-3.972z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#domain_b)",
    d: "M51 61c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10zm0 3c-7.18 0-13-5.82-13-13s5.82-13 13-13 13 5.82 13 13-5.82 13-13 13zm0-3c.604 0 1.477-.685 2.308-2.23C54.365 56.808 55 54.02 55 51c0-3.02-.635-5.808-1.692-7.77C52.477 41.685 51.604 41 51 41c-.604 0-1.477.685-2.308 2.23C47.635 45.192 47 47.98 47 51c0 3.02.635 5.808 1.692 7.77C49.523 60.315 50.396 61 51 61zm0 3c-3.866 0-7-5.82-7-13s3.134-13 7-13 7 5.82 7 13-3.134 13-7 13zM39 53v-3h24v3H39z"
  }))));
};
export default SvgDomain;